import clsx from 'clsx';
import { v4 } from 'uuid';

export default function CheckBox({ checked, className, label, name, onChange }: CheckBoxProps) {

    const containerClasses = clsx('field-check', className);

    const id = `${v4()}-${name}`;

    return <div className={containerClasses}>
        <input checked={checked} id={id} name={name} type="checkbox" onChange={() => onChange(!checked)} />
        <label htmlFor={id}>{label}</label>
    </div>;

}